__turbopack_context__.v({
  "button": "styles-module-scss-module__YLWvkG__button",
  "container": "styles-module-scss-module__YLWvkG__container",
  "descriptionBlock": "styles-module-scss-module__YLWvkG__descriptionBlock",
  "descriptionPoint": "styles-module-scss-module__YLWvkG__descriptionPoint",
  "field": "styles-module-scss-module__YLWvkG__field",
  "fieldError": "styles-module-scss-module__YLWvkG__fieldError",
  "icon": "styles-module-scss-module__YLWvkG__icon",
  "innDataError": "styles-module-scss-module__YLWvkG__innDataError",
  "isLoadingINN": "styles-module-scss-module__YLWvkG__isLoadingINN",
  "label": "styles-module-scss-module__YLWvkG__label",
  "labelDescription": "styles-module-scss-module__YLWvkG__labelDescription",
  "link": "styles-module-scss-module__YLWvkG__link",
  "modalFooterLink": "styles-module-scss-module__YLWvkG__modalFooterLink",
  "modalIntro": "styles-module-scss-module__YLWvkG__modalIntro",
  "modalTitle": "styles-module-scss-module__YLWvkG__modalTitle",
  "name": "styles-module-scss-module__YLWvkG__name",
  "nameWrapper": "styles-module-scss-module__YLWvkG__nameWrapper",
  "registered": "styles-module-scss-module__YLWvkG__registered",
  "signIn": "styles-module-scss-module__YLWvkG__signIn",
  "switchBlock": "styles-module-scss-module__YLWvkG__switchBlock",
  "switchDescription": "styles-module-scss-module__YLWvkG__switchDescription",
  "title": "styles-module-scss-module__YLWvkG__title",
});
